export default "__VITE_ASSET__DAy6wY5w__"